import DataTable from 'components/organisms/data-table'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import tableColumns from './merchant-product-photo-curation-table-columns'

const propTypes = {
  data                        : PropTypes.array,
  pagination                  : PropTypes.object,
  onFetchData                 : PropTypes.func,
  hiddenColumns               : PropTypes.array,
  isLoading                   : PropTypes.bool,
  onChangePhotoCurationStatus : PropTypes.func
}

const defaultProps = {
  hiddenColumns               : [],
  isLoading                   : false,
  onChangePhotoCurationStatus : () => {}
}

/**
 * Table to display Merchant Product for photo curation
 * @param {Array<Object>} data - array of Merchant Product
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const MerchantProductPhotoCurationTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  isLoading,
  onChangePhotoCurationStatus
}) => {

  const columns = useMemo(() => tableColumns({ onChangePhotoCurationStatus }),[ onChangePhotoCurationStatus ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

MerchantProductPhotoCurationTable.propTypes    = propTypes
MerchantProductPhotoCurationTable.defaultProps = defaultProps

export default MerchantProductPhotoCurationTable
